import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../../assets/landing-logo.svg";
import instagram from "../../assets/instagram.svg";
import x from "../../assets/x.svg";
import facebook from "../../assets/facebook.svg";
import linkedin from "../../assets/linkedin.svg";
import location from "../../assets/location.svg";
import phone from "../../assets/phone.svg";
import email from "../../assets/email.svg";
import tiktok from "../../assets/tiktok.svg";
import snapchat from "../../assets/snapchat.svg";
import SocialMediaService from "../../services/SocialMediaService";
import "./style.css";

const Footer = () => {
	const [data, setData] = useState({
		facebook: "",
		instagram: "",
		twitter: "",
		you_tube: "",
		snapchat: "",
		whatsapp: "",
		gmail: "",
	});
	const { t } = useTranslation();
	const socialService = new SocialMediaService();

	useEffect(() => {
		socialService.getList().then((res) => {
			if (res?.status === 200) {
				setData(res?.data?.data);
			}
		});
	}, []);

	return (
		<footer className="landing-footer footer">
			<div className="container">
				<div className="default-section mb-3 row">
					<div className="col-lg-4 col-md-6 col-12 mb-4">
						<img src={logo} alt="logo" className="logo mb-3" />
						<div className="web-view" style={{ width: "65%" }}>
							<div className="align-items-center justify-content-center d-flex gap-16">
								{!!data?.snapchat && (
									<a href={data?.snapchat} target="_blank" rel="noreferrer">
										<img src={snapchat} alt="snapchat" width={30} height={30} />
									</a>
								)}
								{!!data?.instagram && (
									<a href={data?.instagram} target="_blank" rel="noreferrer">
										<img
											src={instagram}
											alt="instagram"
											width={32}
											height={32}
										/>
									</a>
								)}
								{!!data?.twitter && (
									<a href={data?.twitter} target="_blank" rel="noreferrer">
										<img src={x} alt="x" width={32} height={32} />
									</a>
								)}
								{!!data?.facebook && (
									<a href={data?.facebook} target="_blank" rel="noreferrer">
										<img src={facebook} alt="facebook" width={32} height={32} />
									</a>
								)}
								{!!data?.linked_in && (
									<a href={data?.linked_in} target="_blank" rel="noreferrer">
										<img src={linkedin} alt="linkedin" width={32} height={32} />
									</a>
								)}
								{!!data?.tiktok && (
									<a href={data?.tiktok} target="_blank" rel="noreferrer">
										<img src={tiktok} alt="tiktok" width={32} height={32} />
									</a>
								)}
							</div>
						</div>
					</div>
					<div className="col-lg-2 col-md-6 links col-12">
						<p className="sec-title">{t("Quick links")}</p>
						<Link to="/">{t("home")}</Link>
						<Link to="/our-products">{t("Our products")}</Link>
						<Link to="/about-us">{t("about-us")}</Link>
					</div>

					<div className="col-lg-3 col-md-6 links col-12">
						<p className="sec-title">{t("Contact Us")}</p>
						{!!data?.location && (
							<div className="d-flex gap-8 align-items-center mb-4">
								<img src={location} alt="location" width={24} height={24} />
								<a
									href={data?.tiktok}
									className="mb-0"
									target="_blank"
									rel="noreferrer">
									{t("location")}
								</a>
							</div>
						)}
						{data?.call_us && (
							<div className="d-flex gap-8 align-items-center mb-4">
								<img src={phone} alt="phone" width={24} height={24} />
								<a
									href={`tel:${data?.call_us}`}
									className="mb-0"
									target="_blank"
									rel="noreferrer">
									{data?.call_us}
								</a>
							</div>
						)}
						{!!data?.gmail && (
							<div className="d-flex gap-8 align-items-center">
								<img src={email} alt="email" width={24} height={24} />
								<a
									href={`mailto:${data?.gmail}`}
									className="mb-0"
									target="_blank"
									rel="noreferrer">
									{data?.gmail}
								</a>
							</div>
						)}
					</div>
					<div className="col-lg-3 col-md-6 links col-12">
						<p className="sec-title">{t("terms")}</p>
						<Link to="/privacy-policy">{t("privacy_policy_return")}</Link>
						<Link to="/terms-conditions">{t("term and conditions")}</Link>
					</div>
				</div>

				<div className="col-12 mobile-view mobile-social">
					<div className="align-items-center mb-3 justify-content-center d-flex gap-8">
						{!!data?.snapchat && (
							<a href={data?.snapchat} target="_blank" rel="noreferrer">
								<img src={snapchat} alt="snapchat" width={30} height={30} />
							</a>
						)}
						{!!data?.instagram && (
							<a href={data?.instagram} target="_blank" rel="noreferrer">
								<img src={instagram} alt="instagram" width={32} height={32} />
							</a>
						)}
						{!!data?.twitter && (
							<a href={data?.twitter} target="_blank" rel="noreferrer">
								<img src={x} alt="x" width={32} height={32} />
							</a>
						)}
						{!!data?.facebook && (
							<a href={data?.facebook} target="_blank" rel="noreferrer">
								<img src={facebook} alt="facebook" width={32} height={32} />
							</a>
						)}
						{!!data?.linked_in && (
							<a href={data?.linked_in} target="_blank" rel="noreferrer">
								<img src={linkedin} alt="linkedin" width={32} height={32} />
							</a>
						)}
						{!!data?.tiktok && (
							<a href={data?.tiktok} target="_blank" rel="noreferrer">
								<img src={tiktok} alt="tiktok" width={32} height={32} />
							</a>
						)}
					</div>
				</div>
				<div className="footer-animation"></div>
				<p className="text-center power mb-0">
					{t("Powered By")}:{" "}
					<a
						rel="noreferrer"
						href="https://www.cloudliftsolution.com/"
						target="_blank"
						style={{
							color: "#fff",
							textDecoration: "none",
							margin: "0 2px",
						}}>
						Cloud Lift Solutions
					</a>
				</p>
			</div>
		</footer>
	);
};
export default Footer;
